export const VIEWER_TUTORIAL_STORAGE_KEY =
  "10k.viewerGestureTutorial.completed.v1";

export const INITIAL_VIEWER_TUTORIAL_STATE = {
  exploration: "waitingForGuide",
  zoom: "waitingForInstruction",
};

export const COMPLETED_VIEWER_TUTORIAL_STATE = {
  exploration: "complete",
  zoom: "complete",
};

export const isViewerTutorialCompleted = (state) =>
  state?.exploration === "complete" && state?.zoom === "complete";

export const advanceViewerTutorial = (state, event) => {
  switch (event) {
    case "guidePromptSettled":
      return state.exploration === "waitingForGuide"
        ? { ...state, exploration: "drag", zoom: "waitingForInstruction" }
        : state;
    case "guidePromptDeclined":
      return state.exploration === "waitingForGuide"
        ? { exploration: "drag", zoom: "waitingForExploration" }
        : state;
    case "drag":
      return state.exploration === "drag"
        ? { ...state, exploration: "tap" }
        : state;
    case "elementSelected":
      if (state.exploration !== "tap") {
        return state;
      }
      return {
        exploration: "complete",
        zoom: state.zoom === "waitingForExploration" ? "zoom" : state.zoom,
      };
    case "instructionShown":
      if (state.zoom === "complete") {
        return state;
      }
      return {
        ...state,
        zoom: state.exploration === "complete" ? "zoom" : "waitingForExploration",
      };
    case "environmentChanged":
      return state.zoom === "zoom" ? { ...state, zoom: "complete" } : state;
    default:
      return state;
  }
};

export const getViewerGestureTutorialStep = (state, guideIsActive = false) => {
  if (state?.exploration === "drag" || state?.exploration === "tap") {
    return state.exploration;
  }
  return !guideIsActive && state?.zoom === "zoom" ? "zoom" : null;
};

export const getStoredViewerTutorialState = () => {
  if (typeof window === "undefined") {
    return INITIAL_VIEWER_TUTORIAL_STATE;
  }

  try {
    return window.localStorage.getItem(VIEWER_TUTORIAL_STORAGE_KEY) === "true"
      ? COMPLETED_VIEWER_TUTORIAL_STATE
      : INITIAL_VIEWER_TUTORIAL_STATE;
  } catch {
    return INITIAL_VIEWER_TUTORIAL_STATE;
  }
};

export const persistViewerTutorialCompleted = () => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(VIEWER_TUTORIAL_STORAGE_KEY, "true");
  } catch {
    // Local storage can be unavailable in private or embedded contexts.
  }
};
